import { Component, OnInit } from '@angular/core';
import { SearchService } from '../../../search/search.service';
import { SearchParams } from '../../../search/models/search-params.model';
import { SearchStatus } from '../../../search/models/search-status.model';
import { ModalService } from '../../../services/modal.service';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { SearchCriteria, Condition, Clause } from '../../../search/models/search-filter-model';
import { DataTableConfig } from '../../../search/models/data-table-config';
import { SearchEvent } from '../../../search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../../search/search-constants';
import { DataTableEditorService } from '../../../search/results/data-table-editor.service';
import { AlertService } from 'sce-core';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'lfwms-ship-ref-show-mbol-error-log-popup',
  templateUrl: './show-mbol-error-log-popup.component.html',
  styleUrls: ['./show-mbol-error-log-popup.component.css']
})
export class ShowMbolErrorLogPopupComponent implements OnInit {


  public lookupSearchService: SearchService;
  private _mbolkey: string ;
  public searchEventSubscription: Subscription;
  public primarySelectedDocument: any;
  public detailSearchService: SearchService;
  public resourceService: any;
  public searchSearchService: SearchService;

  constructor(public modalService: ModalService,
    public coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService) {
    this.resourceService = this.coreServiceRegistry.resourceService;
  }

  ngOnInit() {
  }
  /*
  Cleanup: Not used currently.
    public registerCallback(callback: any, parentRef: any) {
        this.callbackFunction = callback;
        this.parentRef = parentRef;
    }
  */
  /*
   Ship operation is impelmented as loadByPAge call
    that returns ship action status as table data.
 */
  public initializeComponents(mbolkey: string) {
    this._mbolkey = mbolkey; // will be used for reship operation.
    // initialize the table and search context */
    this.initializeLookupSearchContext();
    // call the ship loadbypage for doing ship action.
    this._doValidateMBOLAndGetResponseTableData(mbolkey);
  }



  /* initialize the table and search context */
  public initializeLookupSearchContext() {
    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = 'mbolerrortd';
    searchParams.isFullFetch = true;
    searchParams.columnCount = 15; ///???
    // LFWM-3071- mbolKey is made as hyperlink to navigate to ship status error log
    searchParams.idProperty = 'mbolKey';
    /* Data editor is needed  for tableheader filter to work.
  Filter might misbehave if datatype is not set properly in metdata from db. */
    searchParams.tableEditor = new DataTableEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    // Client side pagination enabled
    searchParams.paginateLocally = true;
    const tableConfig: DataTableConfig = new DataTableConfig();
    //tableConfig.defaultCellRenderer = ReshipCellRendererComponent;
    tableConfig.enablePagination = true;
    tableConfig.enableFilter = true;
    //tableConfig.showIdAsAHyperLink = true;
    searchParams.dataTableConfig = tableConfig;
    const searchStatus: SearchStatus = new SearchStatus();
    this.lookupSearchService = this.sharedServiceRegistry.createSearchService(searchParams,
      searchStatus);

  }
  
  /*
  API call isp_ValidateMBOL and get response as loadBypage call.
    - clears the search criteria used for loadBypage request
      since it will conflict with logic for localpagination's paging, sort, filter etc.
  */
  private _doValidateMBOLAndGetResponseTableData(mbolkey: string) {

    this.lookupSearchService.clearSearchStatus();
    /* above call required to clear of unexpected behaviour
   -not sending backend calls from second time when multiple parellel requests are sent */
    this.lookupSearchService.setSearchCriteria(this._getNewSearchCriteria(mbolkey));
    // not reflecting?? this.lookupSearchService.pagedData.pageDefinition.pageSize = 1000;
    // this.lookupSearchService.performSearch();
    // subscribe needed as we need to set mbolkey->warningNo mapping and clear search criteria;
    this.lookupSearchService.fetchSearchResults()
      .subscribe((data: any) => {
        this.lookupSearchService.searchStatus.hasResults = true;
        this.lookupSearchService.searchStatus.recordCount = this.lookupSearchService.pagedData.pageDefinition.recordCount;
        const event = new SearchEvent(NEW_SEARCH_EVENT);
        event.isSearchSuccess = true;
        this.lookupSearchService.publishEvent(event);

        // Clear search criteria to work with localPAgination
        this.lookupSearchService.setSearchCriteria(new SearchCriteria());
      });

  }

  /*
  Create custom search criteria for shipping wavekey/ multiple mbolkeys.
  wavekey value is also required even if mbolShip is done with values in mbolKeyList.
  ** (Custom loadByPage request manipulation is done at backend
    as a specific case for ship operation )
  */
  private _getNewSearchCriteria(mbolKey: string) {

    const searchCriteria = new SearchCriteria();
    // Function snippet to reuse clause creation within this method
    const _createSearchClause = (columName: string, value: any) => {
      const clause = new Clause();
      clause.operation = '=';
      clause.column = columName;
      clause.value = value;
      clause.logicalOperation = 'AND';
      return clause;
    };
    const searchCondition = new Condition();
    searchCondition.isMandatory = true;
    searchCondition.operator = 'OR';

    searchCondition.clauses = []; // Initialize clauses array
    searchCondition.clauses.push(_createSearchClause('mbolKey', mbolKey));
    searchCondition.clauses.push(_createSearchClause('keyCount', 0)); // Always 0
    searchCondition.clauses.push(_createSearchClause('errorGroupKey', 0)); // Always 0
    searchCondition.clauses.push(_createSearchClause('isMbolShip', 'Y'));
    searchCondition.clauses.push(_createSearchClause('shipMode', 'MBOL'));

    searchCriteria.conditions.push(searchCondition);

    return searchCriteria;
  }

  public ngOnDestroy() {
    if (this.searchEventSubscription) {
      this.searchEventSubscription.unsubscribe();
    }
  }
}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/ship-ref-popup/show_mbol_error_popup/show-mbol-error-log-popup.component.ts